module.exports = __webpack_public_path__ + "img/footer.bc43ef5a.png";